import React from 'react';

const SkipToMainButton = () => {
  return (
    <a
      href="#main"
      className="h5-sm sr-only z-50 bg-skin-brand font-medium text-black shadow-lg transition focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:h-fit focus:rounded-30 focus:px-10 focus:py-4"
    >
      Skip to Main Content
    </a>
  );
};

export default SkipToMainButton;
